import { Badge } from "@/core/components/ui/badge";
import { SPIFF_RULE_EVENTS_LABELS } from "@/spiff-rules/constants";
import { SpiffRuleEvent } from "@/spiff-rules/spiff-rule";
import { SPIFF_EVENT_BADGE_VARIANTS } from "@/spiffs/constants";

interface SpiffEventBadgeProps {
  triggerEvent: SpiffRuleEvent;
  size?: "md" | "sm" | "lg";
  className?: string;
}

export const SpiffEventBadge = ({
  triggerEvent,
  size = "md",
  className,
}: SpiffEventBadgeProps) => {
  const variant =
    SPIFF_EVENT_BADGE_VARIANTS[
      triggerEvent as keyof typeof SPIFF_EVENT_BADGE_VARIANTS
    ] || "gray";

  const label = SPIFF_RULE_EVENTS_LABELS[triggerEvent] || triggerEvent;

  return (
    <Badge variant={variant} size={size} className={className}>
      {label}
    </Badge>
  );
};
